import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

class VariantGroup extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.update);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.update);
  }

  update = (event) => {
    const newEl = event.detail.data.html.querySelector(
      `variant-group[data-block-id="${this.dataset.blockId}"]`
    );

    if (!newEl) return;

    morph(this, newEl, { childrenOnly: true });
  };
}

if (!customElements.get('variant-group')) {
  customElements.define('variant-group', VariantGroup);
}
